import { render, staticRenderFns } from "./zhuyuan-detail.vue?vue&type=template&id=5ea3a3ba&scoped=true"
import script from "./zhuyuan-detail.vue?vue&type=script&lang=ts"
export * from "./zhuyuan-detail.vue?vue&type=script&lang=ts"
import style0 from "./zhuyuan-detail.vue?vue&type=style&index=0&id=5ea3a3ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea3a3ba",
  null
  
)

export default component.exports